import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-span-full event-img justify-self-end" }
const _hoisted_2 = ["media", "srcset", "sizes", "type"]
const _hoisted_3 = ["srcset", "sizes", "alt"]

import {useContentStore} from "../store/content";

export default /*@__PURE__*/_defineComponent({
  __name: 'PictureComponent',
  setup(__props) {

const contentItem = useContentStore();

const sources = contentItem.featuredImage?.filter((row) => row.tagName === "SOURCE");
const image = contentItem.featuredImage?.filter((row) => row.tagName === "IMG").pop();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("picture", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sources), (item, index) => {
      return (_openBlock(), _createElementBlock("source", {
        key: index,
        media: item.media,
        srcset: item.srcset,
        sizes: item.sizes,
        type: item.type
      }, null, 8, _hoisted_2))
    }), 128)),
    (_unref(image))
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "w-full relative -z-10",
          width: "480",
          height: "531",
          srcset: _unref(image).srcset,
          sizes: _unref(image).sizes,
          alt: _unref(contentItem).title
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})